import { useCallback, useEffect, useRef, useState } from "react";
import { MastermindSectionEnum } from "../../pages/myMastermindCircles/enums/MastermindSectionEnum";
import { getMyMastermindCircles, toogleArchiveDiscuss } from "../../services/communityService";
import { ApiArrayResponseModel } from "./models/ApiResponseModel";
import { MyMastermindModel } from "./models/MyMastermindModel";

export const useMastermindCirclesList = (status: MastermindSectionEnum, page: number = 1, limit: number = 10) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<ApiArrayResponseModel<MyMastermindModel> | null>(null);
    
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            
            setLoading(true);
            const offset = (page - 1) * limit;
            const _data: ApiArrayResponseModel<MyMastermindModel> = await getMyMastermindCircles(
                status === MastermindSectionEnum.archived,
                limit,
                offset
            );
            if(!isMountedRef.current)
                return;
            setData(_data);
        }
        catch { }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [status, page, limit]);

    const toggleArchive = useCallback(async (id: number) => {
        try {
            setLoading(true);
            await toogleArchiveDiscuss(id);
            load();
        }
        catch {}
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [load]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, data, toggleArchive }

}